import SessionService from '../../session/session-service';
import { PENHOR_RURAL } from './../../config';

/**
 * Types
 */

export const DadosClienteTypes = {
    SET_COTACAO: 'dados-cotacao/SET_COTACAO',
    SET_CODIGO_COTACAO: 'dados-cotacao/SET_CODIGO_COTACAO',
    RESET: 'dados-cotacao/RESET',
    SET_PENHOR_RURAL: 'dados-cotacao/SET_PENHOR_RURAL'
};

/**
 * Reducer
 */
let INITIAL_STATE = {
    cotacao: null,
    jornadaPenhorRural: null
};

export function dadosCotacaoReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case DadosClienteTypes.RESET: {
            return { ...INITIAL_STATE };
        }

        case DadosClienteTypes.SET_COTACAO: {
            return {
                ...state,
                cotacao: action.payload.cotacao
            };
        }

        case DadosClienteTypes.SET_PENHOR_RURAL: {
            let jornadaPenhorRural = false;

            if (PENHOR_RURAL) {
                jornadaPenhorRural = true;
                document.title = 'Simulador Penhor Rural';
            }

            const session = SessionService.getSession();
            SessionService.setSession({ ...session, jornadaPenhorRural });

            return {
                ...state,
                jornadaPenhorRural
            };
        }

        case DadosClienteTypes.SET_CODIGO_COTACAO: {
            return {
                ...state,
                cotacao: {
                    ...state.cotacao,
                    codigoCotacao: action.payload.codigoCotacao
                }
            };
        }

        default:
            return state;
    }
}

/**
 * Actions
 */
export const Creators = {
    setCotacao: (cotacao) => ({
        type: DadosClienteTypes.SET_COTACAO,
        payload: { cotacao }
    }),

    setCodigoCotacao: (codigoCotacao) => ({
        type: DadosClienteTypes.SET_CODIGO_COTACAO,
        payload: { codigoCotacao }
    }),

    setPenhorRural: () => ({
        type: DadosClienteTypes.SET_PENHOR_RURAL
    }),

    reset: () => ({
        type: DadosClienteTypes.RESET
    })
};
